import { render, staticRenderFns } from "./BestDeals.vue?vue&type=template&id=5d29fc0a&scoped=true&"
import script from "./BestDeals.vue?vue&type=script&lang=js&"
export * from "./BestDeals.vue?vue&type=script&lang=js&"
import style0 from "./BestDeals.vue?vue&type=style&index=0&id=5d29fc0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d29fc0a",
  null
  
)

export default component.exports